import { ModelType } from '@livv/models';
import { SxProps } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { PlainLink } from '@components/Links';
import { useArticleLink } from '@screens/Books/Book/Nodes/utils/hooks';
import useAmplitude from '@utils/hooks/useAmplitude';
import { TrackingEventName } from '@utils/types/amplitude/events';

interface ExternalPreviewProps {
    articleData: [string, string, boolean];
    sx: SxProps;
}

const ExternalPreview: FC<PropsWithChildren<ExternalPreviewProps>> = ({
    articleData,
    children,
    sx,
}) => {
    const { articleId, link } = useArticleLink(...articleData);
    const { track } = useAmplitude();

    const handleClick = () => {
        if (articleId) {
            track({
                name: TrackingEventName.SIDE_EXTRA_CONTENT_CLICKED,
                params: {
                    target_document_id: articleId,
                    target_document_type: ModelType.LAW_TEXT,
                },
            });
        } else {
            track({
                name: TrackingEventName.CODEARTICLE_OFFICIAL_SOURCE_CLICKED,
            });
        }
    };

    return (
        <PlainLink href={link} onClick={handleClick} sx={sx} underline="never">
            {children}
        </PlainLink>
    );
};

export default ExternalPreview;
